import { render, staticRenderFns } from "./chat-img.vue?vue&type=template&id=4c72ef4c&scoped=true"
import script from "./chat-img.vue?vue&type=script&lang=js"
export * from "./chat-img.vue?vue&type=script&lang=js"
import style0 from "./chat-img.vue?vue&type=style&index=0&id=4c72ef4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72ef4c",
  null
  
)

export default component.exports